var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { size: "modal-small", "close-strict": true },
          on: {
            close: function($event) {
              _vm.$emit("close")
            }
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("h4", [_vm._v("Send E-pay Link")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-body-scroll",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "loader-circle"
              }),
              _vm._v(" "),
              !_vm.showConfirmation
                ? _c("div", { staticClass: "row send-epay-wrapper" }, [
                    _c("div", { staticClass: "col-md-12 text-center mb-3" }, [
                      _c("h5", { staticClass: "font-weight-bold" }, [
                        _vm._v("How do you wish to send the link?")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 text-center mb-2" }, [
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-6 pt-2 pl-0 cc-n-umber radio-button-wrap ml-3"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "pointer text-left w-100 h-100 d-flex align-items-center",
                                on: {
                                  click: function($event) {
                                    _vm.setVia("email")
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  attrs: { type: "radio", id: "email" },
                                  domProps: { checked: _vm.sendVia === "email" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "btn-radio" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "btn-radio-label",
                                    attrs: { for: "email" }
                                  },
                                  [_vm._v("Email")]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-6 pt-2 pl-0 cc-n-umber radio-button-wrap ml-3"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "pointer text-left w-100 h-100 d-flex align-items-center",
                                on: {
                                  click: function($event) {
                                    _vm.setVia("SMS")
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  attrs: { type: "radio", id: "sms" },
                                  domProps: { checked: _vm.sendVia === "SMS" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "btn-radio" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "btn-radio-label",
                                    attrs: { for: "sms" }
                                  },
                                  [_vm._v("SMS")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-12 text-center send-epay-actions mt-4"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center mt-3" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                on: {
                                  click: function($event) {
                                    _vm.$emit("close")
                                  }
                                }
                              },
                              [_vm._v("\n              Cancel\n            ")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center mt-3" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    _vm.showConfirmation = true
                                  }
                                }
                              },
                              [_vm._v("\n              Send\n            ")]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _c(
                    "div",
                    {
                      staticClass: "row send-epay-wrapper",
                      class: [_vm.loading ? "opacity-2" : ""]
                    },
                    [
                      _c("div", { staticClass: "col-md-12 text-center mb-3" }, [
                        _c("h5", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            "\n            Are you sure you want to send an e-pay link via " +
                              _vm._s(_vm.sendVia) +
                              " for the remaining\n            balance of $" +
                              _vm._s(_vm.job.remaining_price) +
                              "?\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-12 text-center send-epay-actions mt-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center mt-3" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  on: {
                                    click: function($event) {
                                      _vm.showConfirmation = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              No, go back\n            "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center mt-3" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: { click: _vm.sendLink }
                                },
                                [
                                  _vm._v(
                                    "\n              Yes, send link\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17154a36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17154a36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/SendEpayLink.vue
// module id = null
// module chunks = 